import React, { useState } from 'react';
import RegistrationLayout from '../../layouts/registration/RegistrationLayout';
import UserForm, { UserFormTitle } from './steps/user-form';
import CompanyStep, { CompanyStepTitle } from './steps/company-step';
import CompanySize, { CompanySizeTitle } from './steps/company-size';
import UseCase, { UseCaseTitle } from './steps/use-case';
import FirstContent, { FirstContentTitle } from './steps/first-content';
import TeamInvite, { TeamInviteTitle } from './steps/team-invite';
import EmailVerification from './email-verification';

const OnboardingLayout = ({ userProfile = {}, user = {} }) => {
    const nameStep = { title: <UserFormTitle />, component: <UserForm /> };
    const restSteps = [
        { title: <CompanyStepTitle />, component: <CompanyStep /> },
        { title: <CompanySizeTitle />, component: <CompanySize /> },
        { title: <UseCaseTitle />, component: <UseCase /> },
        { title: <FirstContentTitle />, component: <FirstContent /> },
        { title: <TeamInviteTitle />, component: <TeamInvite /> }
    ];
    const components = userProfile ? restSteps : [nameStep, ...restSteps];
    const totalSteps = components.length;

    const [currStep, setCurrStep] = useState(0);
    const [isComplete, setIsComplete] = useState(false);

    const handleNextStep = () => {
        if (currStep < totalSteps - 1) {
            setCurrStep(currStep + 1);
        } else {
            setIsComplete(true);
        }
    };

    const onBackClick = () => {
        if (currStep > 0) setCurrStep(currStep - 1);
    };

    const current = components[currStep];

    return (
        <>
            {!isComplete && (
                <RegistrationLayout
                    title={current.title}
                    currStep={currStep + 1}
                    totalSteps={totalSteps}
                    onBackClick={onBackClick}
                >
                    {React.cloneElement(current.component, { onChangeStep: handleNextStep })}
                </RegistrationLayout>
            )}
            {isComplete && <EmailVerification user={user} />}
        </>
    );
};

export default OnboardingLayout;
